import { useEffect } from 'react';
import {
  resetRestrictionState,
  setRestrictionBlockedHandler,
  setRestrictionRefreshHandler,
} from '@cobu/api-client';
import {
  requestRestrictionRefresh,
  resetRestrictionRefresh,
} from '../lib/session/restrictionRefresh';
import { showErrorMessage } from '../utils/messageToast';
import { Strings } from '../constants/Strings';

/**
 * Reconciles restriction state on a newer `X-Session-State-Version` or a
 * `403 RESIDENT_RESTRICTED`. Initial state comes from the resolve at boot.
 */
export const useRestrictionLiveRefresh = (enabled: boolean): void => {
  useEffect(() => {
    if (!enabled) return;

    setRestrictionRefreshHandler(requestRestrictionRefresh);

    setRestrictionBlockedHandler(() => {
      showErrorMessage(Strings.get().restriction.actionUnavailable);
      requestRestrictionRefresh();
    });

    return () => {
      resetRestrictionState();
      resetRestrictionRefresh();
    };
  }, [enabled]);
};
